import { createContext, useContext } from 'react';
import type { CrumbContribution } from '../lib/breadcrumbTypes';

export type BreadcrumbEntry = {
  owner: symbol;
  scope: string;
  contribution: CrumbContribution;
};

export interface BreadcrumbWriter {
  scope: string;
  put: (entry: BreadcrumbEntry) => void;
  remove: (owner: symbol, scope: string) => void;
}

export const BreadcrumbWriteContext = createContext<BreadcrumbWriter | null>(null);

export const BreadcrumbReadContext = createContext<readonly CrumbContribution[]>([]);

export const useBreadcrumbContributions = () => useContext(BreadcrumbReadContext);
